
import { supabase } from "@/integrations/supabase/client";

/**
 * Utility function to fetch collection details from the database
 */
export const fetchCollectionDetailsFromDb = async (collectionId: string) => {
  const { data, error } = await supabase
    .from("collections")
    .select("name, color")
    .eq("id", collectionId)
    .single();

  if (error) {
    console.error("Error fetching collection details:", error);
    return null;
  }

  return data;
};
